<div class="row align-items-center pb-2 flex-row-reverse flex-md-row">
    <div class="col-md-3 mr-auto mb-2 mb-md-0" style="padding: 6px;">
        <small class="text-muted"> {{ 'selectedCount' | translate: {count : selectedCountElements} }} </small>
    </div>

    <div>
        <button
            class="cdx-button cdx-button--icon cdx-button--lg mr-1"
            ngbTooltip="{{ 'edit' | translate | titlecase }}"
            *ngIf="selectedCountElements == 1"
            (click)="editClick()"
        >
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','edit']"></fa-icon>
        </button>

        <button
            class="cdx-button cdx-button--icon cdx-button--lg mr-1"
            placement="top-right auto"
            ngbTooltip="{{ 'envelope.signatory.modalAdd.removeSignatoryText' | translate }}"
            *ngIf="selectedCountElements > 0"
            (click)="removeClick()"
        >
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','minus-circle']"></fa-icon>
        </button>

        <button
            class="cdx-button cdx-button--icon cdx-button--lg mr-1"
            placement="top-right auto"
            ngbTooltip="{{ 'envelope.signatory.modalAdd.addNewSignatoryText' | translate }}"
            (click)="addClick()"
        >
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','plus-circle']"></fa-icon>
        </button>

    </div>

    <cdx-toolbar-search
        (onTyping)="onSearch($event)"
        [value]="searchValue"
        [placeholder]="'search' | translate | titlecase"
        [maxlength]="255"
        [debounceTime]="600"
    >
    </cdx-toolbar-search>
</div>
